import IDepartment from "../models/macrowayFeedback/IDepartment";
import IMacroWayFeedback from "../models/macrowayFeedback/IMacroWayFeedback";
import networkService from "./networkService";

class MacroWayFeedbackService {

    async getDepartments() : Promise<IDepartment[]> {
        const result = await networkService.get("macroway/feedback/departments");

        if (result.isSuccessful) {
            return result.data as IDepartment[];
        }

        throw new Error();
    }

    async submitFeedback(feedback: IMacroWayFeedback) : Promise<void> {
        const result = await networkService.put<IMacroWayFeedback, void>("macroway/feedback", feedback);
        if (!result.isSuccessful) {
            throw new Error();
        }
    }
}

const macroWayFeedbackService = new MacroWayFeedbackService();
export default macroWayFeedbackService;